import { TAddress } from 'models';

export const getVisibleAddressesLength = (form: TAddress[]) => form.reduce((prev, current) => {
  if (!current.deleted) {
    return prev + 1;
  }

  return prev;
}, 0);
